<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { ONGOING_CAMPAIGN_EMPTY_STATE_CONTENT } from './CampaignEmptyStateContent';

import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
});

const { tm } = useI18n();
const previewContent = computed(() =>
  tm('CAMPAIGN.LIVE_CHAT.EMPTY_STATE.PREVIEW')
);
const previewCampaigns = computed(() =>
  ONGOING_CAMPAIGN_EMPTY_STATE_CONTENT.map(campaign => {
    const content = previewContent.value[campaign.previewId];

    return {
      ...campaign,
      title: content.TITLE,
      message: content.MESSAGE,
      sender: { ...campaign.sender, name: content.SENDER },
      inbox: { ...campaign.inbox, name: previewContent.value.INBOX },
    };
  })
);
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="flex flex-col gap-4 p-px">
        <CampaignCard
          v-for="campaign in previewCampaigns"
          :key="campaign.id"
          :title="campaign.title"
          :message="campaign.message"
          :is-enabled="campaign.enabled"
          :status="campaign.campaign_status"
          :sender="campaign.sender"
          :inbox="campaign.inbox"
          :scheduled-at="campaign.scheduled_at"
          is-live-chat-type
        />
      </div>
    </template>
  </EmptyStateLayout>
</template>
